import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "@/axios";
import { auth } from "./auth";
import { form } from "./form";
import { toolbar } from "./toolbar";
import { filters } from "./filters";
import { administrators } from "./administrators";
import { recipes } from "./recipes";
import { products } from "./products";
import { makers } from "./makers";
import { maker_administrators } from "./maker_administrators";
import { password } from "./password";
import { common } from "./common";
import { passwordReissue } from "./passwordReissue";
import { import_recipes } from "./import_recipes";
import { import_products } from "./import_products";
import { import_masters } from "./import_masters";
import { message } from "./message";
import { maintenance } from "./maintenance";
import { requests } from "./requests";
import { templates } from "./templates";
import { users } from "./users";
import {download_recipes} from "./download_recipes";
import {download_products} from "./download_products";
import { news } from "./news";
import { reminders } from "./reminders";
import { inquiries } from "./inquiries";
import { masters } from "./masters";
import { answers } from "./answers";
import { inquirie } from "./inquiries";
import { questionnaires } from "./questionnaires";
import { topics } from "./topics";
import { push_advertisments } from "./push_advertisments";
import { reminder_histories } from "./reminder_histories";

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    sidebarShow: 'responsive',
    sidebarMinimize: false
  },
  mutations: {
    toggleSidebarDesktop (state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile (state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set (state, [variable, value]) {
      state[variable] = value
    }

  },
  actions: {},
  getters: {},
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_APP_NAME || "VUE_APP_APP_NAME",
      paths: [
        "auth.accessToken",
        "auth.refreshToken",
        "auth.expiresIn",
        "auth.accessTokenClaims",
        "auth.firebaseIdToken",
        "auth.firebaseRefreshToken"
      ],
      storage: window.localStorage
    })
  ],
  modules: {
    auth,
    form,
    toolbar,
    filters,
    administrators,
    recipes,
    products,
    makers,
    maker_administrators,
    password,
    common,
    passwordReissue,
    import_recipes,
    import_products,
    import_masters,
    message,
    maintenance,
    requests,
    templates,
    users,
    download_recipes,
    download_products,
    news,
    reminders,
    inquiries,
    masters,
    answers,
    questionnaires,
    topics,
    push_advertisments,
    inquiries: inquirie,
    reminder_histories
  }
});

store.$axios = axios;

export default store;
